import React from 'react';
import { Text, themeVars } from '@eds-web/react';

import { StyledPrizeSteps, StyledMobilePrizeSteps, StyledMobilePrizeHeader } from './Prizes.style';
import { CircleProgress } from '../common/CircleProgress';
import { useTranslation } from 'react-i18next';

export const PrizeSteps: React.FC<{
    currentStep: number;
    onStepChange?: (step: number) => void;
    maxStep: number;
    steps: string[];
}> = ({ currentStep, maxStep, steps }) => {
    const { t } = useTranslation();
    return (
        <>
            <StyledPrizeSteps
                orientation={'vertical'}
                steps={steps}
                aria-label={'steps'}
                currentStep={currentStep}
            />
            <StyledMobilePrizeSteps>
                <CircleProgress value={maxStep} maxValue={steps?.length} />
                <StyledMobilePrizeHeader>
                    <Text variant={'uiLGBold'}>{steps[maxStep - 1]}</Text>
                    {Boolean(steps.length !== maxStep && steps[maxStep]) && (
                        <Text
                            style={{
                                marginTop: 10,
                                color: themeVars.color.transparent.light['065']
                            }}
                            variant={'paragraphMD'}
                        >
                            {t('epic.esport.progress.mobile.next.tile', { step: steps[maxStep] })}
                        </Text>
                    )}
                </StyledMobilePrizeHeader>
            </StyledMobilePrizeSteps>
        </>
    );
};
